import { fetchDataForDashboardOperativa } from 'pages/Output/actions'
import { getFilterModelFromFilterBar } from '../utils/dataTransformer'
import { UNIT_OF_MEASURE_SECTION } from '../utils/constants'
const { isEmpty } = require('lodash')
const { useState, useEffect } = require('react')

const initialData = {
  summary: [],
  logistic: [],
  store: []
}
export const useDashboardData = ({ scenarioId, serverFilter }) => {
  const [dashboardData, setDashboardData] = useState(initialData)
  const [isLoadedData, setIsLoadedData] = useState(false)

  useEffect(() => {
    if (!isEmpty(scenarioId) && !isEmpty(serverFilter)) {
      getData(scenarioId, serverFilter).then((res) => {
        setDashboardData(res?.body || initialData)
        setIsLoadedData(true)
      })
    }
  }, [scenarioId, serverFilter])

  useEffect(() => {
    if (!isEmpty(dashboardData)) {
    }
  }, [dashboardData])
  return { dashboardData, isLoadedData }
}

const getData = async (scenarioId, serverFilter) => {
  if (isEmpty(scenarioId) || isEmpty(serverFilter)) {
    return initialData
  }

  const uom = serverFilter[UNIT_OF_MEASURE_SECTION]
  delete serverFilter[UNIT_OF_MEASURE_SECTION]
  const body = { filter: getFilterModelFromFilterBar(serverFilter) }
  return await fetchDataForDashboardOperativa(scenarioId, uom, body)
}
